/**
 * Sorts line item property keys for consistent display in Shopify admin (Web, POS, iOS App).
 * 1. Hidden properties (prefixed with _) appear before visible properties
 * 2. Hidden properties sorted alphabetically A->Z
 * 3. Visible properties sorted alphabetically A->Z
 *
 * @param {Object} properties - Line item properties object
 * @returns {Object} New object with same keys/values in sorted order
 */
export function sortLineItemProperties(properties) {
  const keys = Object.keys(properties);
  const hidden = keys.filter((k) => k.startsWith("_")).sort();
  const visible = keys.filter((k) => !k.startsWith("_")).sort();
  const sortedKeys = [...hidden, ...visible];
  return sortedKeys.reduce((acc, key) => {
    acc[key] = properties[key];
    return acc;
  }, {});
}
